import { theme as defaultTheme } from '@bigcommerce/big-design-theme';
import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = /*#__PURE__*/createGlobalStyle(["", " body{font-family:", ";}"], normalize(), _ref => {
  let {
    theme
  } = _ref;
  return theme.typography.fontFamily;
});
GlobalStyles.defaultProps = {
  theme: defaultTheme
};